<template>
    <div>
        <page-title>许可协议</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <router-link to="/dashboard/admin/agreement/edit">
                            <el-button type="text">手动添加</el-button>
                        </router-link>
                    </div>
                    <div flex="dir:right box:last cross:center">
                        <div>
                            <el-form :inline="true">
                                <el-form-item style="margin-bottom: 0; margin-top: 1px">
                                    <el-date-picker
                                            size="mini"
                                            @change="dateChange"
                                            v-model="date"
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0; margin-top: 1px">
                                    <el-select
                                               v-model="app_id"
                                               clearable size="mini"
                                               placeholder="应用" @change="search()">
                                        <el-option v-for="item in apps" :key="item.id" :label="item.display_name"
                                                   :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item style="margin-bottom: 0; max-width: 150px">
                                    <el-input v-model="keyword"
                                              @keyup.enter.native="search()"
                                              size="mini"
                                              placeholder="协议名称"
                                              suffix-icon="el-icon-search"/>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <template slot="empty">
                    <router-link to="/dashboard/admin/agreement/edit">
                        <el-button type="primary" round>
                            添加许可协议
                        </el-button>
                    </router-link>
                </template>
                <el-table-column prop="title" label="协议名称">
                </el-table-column>
                <el-table-column label="平台/应用名称">
                    <template slot-scope="scope">
                        <span v-if="scope.row.app">
                            {{scope.row.app.display_name}}
                        </span>
                        <span v-else>
                            SaaS平台
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_lasted === 1" style="color: #6AC33D;">
                            当前显示协议
                        </span>
                        <span v-else>
                            历史协议
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="add_time" label="修订时间">
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <router-link v-if="scope.row.is_delete === 0"
                                     :to="'/dashboard/admin/agreement/edit?id='
                                        + scope.row.id">编辑
                        </router-link>
                        <span v-else style="color: #999">已删除</span>
                        <span class="text-split">|</span>
                        <router-link
                                     :to="'/dashboard/admin/agreement/edit?is_view=true&id='
                                        + scope.row.id">查看
                        </router-link>
                        <span class="text-split">|</span>
                        <el-button v-if="scope.row.is_delete === 0" type="text" @click="deleteItem(scope.row)">删除
                        </el-button>
                        <el-button v-else type="text" @click="recoveryItem(scope.row)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>
        </page-body>
    </div>
</template>
<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    data() {
        return {
            loading: false,
            list: null,
            pagination: null,
            begin_time: null,
            end_time: null,
            keyword: '',
            date: null,
            start_at: null,
            end_at: null,
            app_id: null,
            apps: [{'id': 0, 'display_name': 'SaaS平台'}]
        }
    },
    created() {
        this.user_id = this.$route.query.user_id || null
        this.loadData(0)
        this.searchApps()
    },
    methods: {
        loadData(page) {
            if (this.date) {
                this.start_at = this.date[0]
                this.end_at = this.date[1]
            } else {
                this.start_at = null
                this.end_at = null
            }
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/agreement/index',
                    params: {
                        page: page,
                        keyword: this.keyword,
                        start_at: this.start_at,
                        end_at: this.end_at,
                        app_id: this.app_id
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        deleteItem(item) {
            new Promise(resolve => {
                this.$confirm('确认删除该内容?', '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = 1
                this.loading = true
                axios({
                    url: 'admin/agreement/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        this.$message.success(e.data.msg)
                        item.is_delete = 1
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        recoveryItem(item) {
            const data = helper.clone(item)
            data.is_delete = 0
            axios({
                url: 'admin/agreement/update',
                method: 'post',
                data: data
            }).then(e => {
                this.loading = false
                if (e.data.code === 0) {
                    this.$message.success(e.data.msg)
                    item.is_delete = 0
                } else {
                    this.$message.error(e.data.msg)
                }
            })
        },
        dateChange() {
            this.loadData(0)
        },
        searchApps() {
            axios({
                url: 'admin/app/index'
            }).then(e => {
                if (e.data.code === 0) {
                    this.apps.push(...e.data.data.list)
                } else {
                    this.apps = []
                }
            }).catch(e => {
                this.apps = []
            })
        }
    }
}
</script>

<style scoped>

</style>
